import React from "react";

import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

export default function SubscriptionPagination({
  page,
  setPage,
  pageSize,
  setPageSize,
  totalItems,
  totalPages,
  firstVisibleItem,
  lastVisibleItem,
}) {
  if (totalItems === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 border-t border-slate-100 px-4 py-4 dark:border-slate-800 sm:flex-row sm:items-center sm:justify-between sm:px-5">
      <div className="flex items-center gap-3">
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Affichage{" "}
          <strong className="text-slate-900 dark:text-white">
            {firstVisibleItem}
          </strong>{" "}
          à{" "}
          <strong className="text-slate-900 dark:text-white">
            {lastVisibleItem}
          </strong>{" "}
          sur{" "}
          <strong className="text-slate-900 dark:text-white">
            {totalItems}
          </strong>
        </p>

        <select
          value={pageSize}
          onChange={(event) =>
            setPageSize(event.target.value)
          }
          className="rounded-xl border border-slate-200 bg-white px-2 py-1.5 text-xs font-semibold text-slate-600 outline-none dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
          aria-label="Nombre d’éléments par page"
        >
          {[10, 15, 25, 50].map((value) => (
            <option key={value} value={value}>
              {value} / page
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center justify-between gap-3 sm:justify-end">
        <button
          type="button"
          onClick={() => setPage(page - 1)}
          disabled={page <= 1}
          className="grid h-10 w-10 place-items-center rounded-xl border border-slate-200 text-slate-600 transition hover:border-indigo-300 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:text-slate-300"
          aria-label="Page précédente"
        >
          <FaChevronLeft />
        </button>

        <span className="min-w-[100px] text-center text-sm font-bold text-slate-700 dark:text-slate-200">
          Page {page} / {totalPages}
        </span>

        <button
          type="button"
          onClick={() => setPage(page + 1)}
          disabled={page >= totalPages}
          className="grid h-10 w-10 place-items-center rounded-xl border border-slate-200 text-slate-600 transition hover:border-indigo-300 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:text-slate-300"
          aria-label="Page suivante"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}